import React, { useEffect, useState } from "react";
import Modal from "../../../components/Modal/Modal";
import { TitleModalFilter } from "../../stake-for-voting/style";
import { Form, Row, Space } from "antd";
import styled from "styled-components";
import {
  LabelFormPopupDetail,
  StakeNotify,
  ValueFormPopupDetail,
} from "../style";
import { NoteIcon } from "../../../components/Icons/NoteIcon";
// import { FormInput } from "../../../components/Form";
import { AuthFormInputSpan, Sendcode } from "../../auth/styles";
import { useApp } from "../../../contexts";
import { MyButton } from "../../../components/Button/style";
import {
  confirmOTPVerify,
  resendOTPVerify,
  sendOTPVerify,
} from "../../../services/app";
import { Cell, CellTitle, CellValue } from "../../withdraw/modal/styles";
import { InputOtp } from "../../../components/TwoFA/style";
import FormInput from "../../../components/FormCustom2/Input";
import { StatusEnabled2FA } from "../../../constants";

const ModalContainer = styled(Modal.Container)`
  padding-left: 60px;
  padding-right: 60px;
  padding-top: 52px;
  padding-bottom: 40px;
  width: 850px;
  background: #f5f5f5;
  @media (max-width: 640px) {
    padding: 30px 20px;
  }
`;

const ContentWaper = styled.div`
  max-height: 80vh;
  overflow-y: auto;
  padding: 0 24px 20px 8px;
  &::-webkit-scrollbar {
    display: none;
  }
`;

const ModalDetail = ({
  onClose,
  startDate,
  endDate,
  amount,
  bonus,
  duration,
  onSubmit,
}) => {
  const { T, setAlert, user, isUserSocial } = useApp();
  const [loading, setLoading] = useState(false);
  const [password, setPassword] = useState();
  const [twoFa, setTwoFa] = useState();
  const [otp, setOtp] = useState("");
  const [sentOtp, setSentOtp] = useState({
    data: null,
    time: 0,
  });
  const handleSubmit = async () => {
    try {
      const result = await confirmOTPVerify({
        verify_request_id: sentOtp?.data,
        otp_code: otp,
        password: password,
        twofa_code: twoFa,
      });
      if (result?.status !== 200) {
        setAlert({
          type: "error",
          text:
            result?.data?.error?.message ||
            T("Some error happened. Please try again later."),
        });
      } else {
        await onSubmit();
      }
    } catch (error) {
      console.log(error);
    }
  };

  const onSentOtp = async () => {
    setLoading(true);
    const result = sentOtp?.data
      ? await resendOTPVerify(sentOtp?.data)
      : await sendOTPVerify();
    if (result.status === 200) {
      setSentOtp({ data: result?.data?.data, time: 180 });
    } else {
      if (!(result?.data?.error?.validates || []).length) {
        setAlert({
          type: "error",
          text:
            result?.data?.error?.message ||
            T("Some error happened. Please try again later."),
        });
      }
    }
    setLoading(false);
  };

  useEffect(() => {
    const timer = setInterval(() => {
      setSentOtp((prevState) => {
        if (prevState?.time > 0) {
          return { ...prevState, time: prevState?.time - 1 };
        }
        return { ...prevState };
      });
    }, 1000);
    return () => {
      clearInterval(timer);
    };
  }, []);

  return (
    <Modal>
      <Modal.ModalBg onClick={onClose} />
      <ModalContainer onClose={onClose}>
        <ContentWaper>
          <TitleModalFilter>{T("Confirm Staking Request")}</TitleModalFilter>
          <div className="flex flex-col mt-[29px] lg:mt-[37px]">
            <div className="lg:flex grid items-center pt-[10px]">
              <LabelFormPopupDetail style={{ minWidth: 252 }}>
                {T("Product")}
              </LabelFormPopupDetail>
              <ValueFormPopupDetail>{T("Stake SGT")}</ValueFormPopupDetail>
            </div>
            <div className="lg:flex grid items-center pt-[10px]">
              <LabelFormPopupDetail style={{ minWidth: 252 }}>
                {T("Effective Date")}
              </LabelFormPopupDetail>
              <ValueFormPopupDetail>{startDate}</ValueFormPopupDetail>
            </div>
            <div className="lg:flex grid items-center pt-[10px]">
              <LabelFormPopupDetail style={{ minWidth: 252 }}>
                {T("Maturity Date")}
              </LabelFormPopupDetail>
              <ValueFormPopupDetail>{endDate}</ValueFormPopupDetail>
            </div>
            <div className="lg:flex grid items-center pt-[10px]">
              <LabelFormPopupDetail style={{ minWidth: 252 }}>
                {T("Amount")}
              </LabelFormPopupDetail>
              <ValueFormPopupDetail>{amount} SGT</ValueFormPopupDetail>
            </div>
            <div className="lg:flex grid items-center pt-[10px]">
              <LabelFormPopupDetail style={{ minWidth: 252 }}>
                {T("Duration")}
              </LabelFormPopupDetail>
              <ValueFormPopupDetail>{duration}</ValueFormPopupDetail>
            </div>
            <div className="lg:flex grid items-center pt-[10px]">
              <LabelFormPopupDetail style={{ minWidth: 252 }}>
                {T("xSGT Voting Power")}
              </LabelFormPopupDetail>
              <ValueFormPopupDetail className="!border-b-0">
                {bonus}
              </ValueFormPopupDetail>
            </div>
            <StakeNotify className="!mt-[24px] lg:!mt-[16px]">
              <NoteIcon />
              <div>
                {T(
                  "This is a locked staking product. It means that you can not withdraw the staked asset before the maturity date."
                )}
              </div>
            </StakeNotify>
            {!isUserSocial && (
              <div className="flex items-center mt-[25px] lg:mt-[20px]  flex-col sm:flex-row">
                <LabelFormPopupDetail style={{ minWidth: 213 }}>
                  {T("Confirm Password")}
                </LabelFormPopupDetail>
                <FormInput
                  type="password"
                  className="w-full"
                  value={password}
                  onChange={(event) => {
                    setPassword(event.target.value);
                  }}
                  placeholder={T("Enter your password")}
                />
              </div>
            )}
            <div className="flex mt-[25px] lg:mt-[20px] relative  flex-col sm:flex-row">
              <LabelFormPopupDetail style={{ minWidth: 213 }}>
                {T("Enter Verification Code")}
              </LabelFormPopupDetail>
              <FormInput
                onChange={(event) => setOtp(event.target.value)}
                readOnly={!sentOtp?.time}
                className="pr-[110px] w-full"
                placeholder={
                  sentOtp?.time <= 0
                    ? T("Click “Send Code”")
                    : T("Please enter code")
                }
              />
              <div className="absolute right-0 bottom-[80px] w-[100px] z-10">
                <AuthFormInputSpan onClick={onSentOtp}>
                  {sentOtp?.time > 0 ? (
                    `${sentOtp?.time}s`
                  ) : (
                    <Sendcode
                      className={
                        "auth absolute right-0 lg:bottom-[-22px] bottom-[-15px] w-[100px]"
                      }
                    >
                      {T("Send Code")}
                    </Sendcode>
                  )}
                </AuthFormInputSpan>
              </div>
            </div>
            {!!user?.is_twofa ? (
              <Row className="mt-[25px] lg:mt-[20px] ">
                <Cell
                  className="flex flex-col sm:flex-row"
                  style={{ marginBottom: 0 }}
                >
                  <CellTitle style={{ marginBottom: 12 }}>
                    {T("Enter 2FA code")}
                  </CellTitle>
                  <CellValue>
                    <InputOtp
                      className={"inline"}
                      value={twoFa}
                      onChange={(event) => {
                        setTwoFa(event);
                      }}
                    />
                  </CellValue>
                </Cell>
              </Row>
            ) : null}
            <div className="lg:flex grid gap-4 mt-[52px] lg:mt-[44px] justify-center">
              <MyButton onClick={onClose}>{T("Cancel")}</MyButton>
              <MyButton
                className="confirm"
                disabled={
                  !otp ||
                  (!!user?.is_twofa && !twoFa) ||
                  (!isUserSocial && !password)
                }
                onClick={handleSubmit}
              >
                {T("Stake")}
              </MyButton>
            </div>
          </div>
        </ContentWaper>
      </ModalContainer>
    </Modal>
  );
};

export default ModalDetail;
